import React from 'react'
import { connect } from 'react-redux'
import { setHot100Position, fetchHot100IfNeeded, fetchHot100Position } from '~/features/actions'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Hot100Banner } from '~/main/components/Hot100Banner';
class Hot100 extends React.Component {

  constructor() {
    super();
    this.state = {
      data: [],
      ws: null
    }
    //let h100count = null
    let h100Timeout = null
    this.ws = null
    this.supportsWebSockets = typeof window !== 'undefined' && 'WebSocket' in window && window.WebSocket.CLOSING === 2;
  }


  componentDidMount() {
    document.getElementsByTagName('body')[0].className = 'hot100';
    const { match, history } = this.props
    var _this = this
    function getTitle(_this) {
      _this.getPosition()
      _this.h100Timeout = setTimeout(getTitle, 30000, _this)
    }
    this.h100Timeout = setTimeout(getTitle, 1000, this)
    this.connect();
  }


  componentWillUnmount() {
    document.getElementsByTagName('body')[0].className = '';
    clearTimeout(this.scrollTimeOut)
    clearTimeout(this.h100Timeout)
    //clearTimeout(this.nPTimeout)
    this.disconnect()
  }

  componentDidUpdate() {
    // window.scrollTo(0, document.body.scrollHeight);
    //this.scrollTo(0, 100)
    var lastelmnt = document.querySelector('.section:nth-child(2)')
    if(lastelmnt) { lastelmnt.scrollIntoView({ behavior: "instant", block: "start", inline: "nearest" }); }

    var elmnt = document.querySelector('.section')
    if(elmnt) { elmnt.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" }); }

  }

  disconnect() {
    if (this.supportsWebSockets)
     this.ws.close()
  }
  connect() {
    if (this.supportsWebSockets) {

      const { dispatch } = this.props
      this.ws = new WebSocket("wss://data.4zzz.org.au:5085/hot100");
      let that = this; // cache the this
      var connectInterval;

      // websocket onopen event listener
      this.ws.onopen = () => {
          console.log("connected websocket main component");

          this.setState({ ws: this.ws });

          that.timeout = 250; // reset timer to 250 on open of websocket connection 
          clearTimeout(connectInterval); // clear Interval on on open of websocket connection
      };

      // websocket onclose event listener
      this.ws.onclose = e => {
          console.log(
              `Socket is closed. Reconnect will be attempted in ${Math.min(
                  10000 / 1000,
                  (that.timeout + that.timeout) / 1000
              )} second.`,
              e.reason
          );

          that.timeout = that.timeout + that.timeout; //increment retry interval
          connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
      };

      // websocket onerror event listener
      this.ws.onerror = err => {
          console.error(
              "Socket encountered error: ",
              err.message,
              "Closing socket"
          );

          this.ws.close();
      };

      this.ws.onmessage = message => {
        let data = JSON.parse(message.data);
        if(data.hot100Count) {
          console.log(data.hot100Count);
          dispatch(setHot100Position(data.hot100Count));
        }
      }
    } 

  }

  /**
   * utilited by the @function connect to check if the connection is close, if so attempts to reconnect
   */
  check() {
    if(this.state) {
      const { ws } = this.state;
      if (!ws || ws.readyState == WebSocket.CLOSED) this.connect(); //check if websocket instance is closed, if so call `connect` function.
    }
  }



  scrollTo(to, duration) {
    var start = document.body.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;
    if (this.scollTimeOut) {
      clearTimeout(this.scrollTimeOut)
    }

    var easeInOutQuad = function (t, b, c, d) {
      t /= d/2;
    	if (t < 1) return c/2*t*t + b;
    	t--;
    	return -c/2 * (t*(t-2) - 1) + b;
    }

    var _this = this
    var animateScroll = function(){
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        document.body.scrollTop = val;
        if(currentTime < duration) {
          _this.scrollTimeOut = setTimeout(animateScroll, increment);
        }
    }
    animateScroll();
  }

  getPosition() {
    const { dispatch } = this.props
    dispatch(fetchHot100Position())
  }

  getData() {
    const { dispatch } = this.props
    dispatch(fetchHot100IfNeeded())
  }

  render() {
    const { hot100 } = this.props
    const count = hot100.items.length
    let chunks = []

    if (count > 0) {
      for (let i = 0; i < count; i++) {
        chunks.push(hot100.items.slice(i, i + 1))
      }

      /*let mod = count % 10
      let div = Math.floor(count / 10)
      if (div >= 0) {
        let n = 0
        let x = 0
        while (n <= div) {
          let y = mod + n * 10
          if (n === 0) {
            for (let i = 0; i < mod; i++) {
              chunks.push(data.slice(i, i + 1))
            }
          }
          else {
            chunks.push(data.slice(x, y))
          }
          x = y
          n++;
        }
        console.log(chunks)
      }*/

    }
    const list = chunks.map((chunk, chunkindex) => {
      var cssHSL = "hsl(" + 360 * Math.random() + ',' +
                 (25 + 70 * Math.random()) + '%,' +
                 (85 + 10 * Math.random()) + '%)';
     var fgHSL = "hsl(" + 360 * Math.random() + ',' +
                (25 + 70 * Math.random()) + '%,' +
                (85 + 10 * Math.random()) + '%)';
      let secClass = 'section group'
      if (chunk.length === 1) {
        secClass = "section single"
      }
      return (
        <div className={secClass} key={chunkindex} style={{minHeight: '100vh', position: 'relative'}}>
        { chunk.map((item, index) => {
            return (
              <div className="item" key={index} style={{minHeight: '10vh'}}>
                <div className="listing">
                  <AnimationOnScroll animateIn="bounceIn" offset={0}>
                    <div className="number">{item["Rank"]}</div>
                  </AnimationOnScroll>
                  <AnimationOnScroll animateIn="slideInRight" offset={0} delay={200}>
                    <div className="artist">{item["Artist"]}</div>
                  </AnimationOnScroll>
                  <AnimationOnScroll animateIn="flipInX" offset={0} delay={800}>
                    <div className="title">{item["Track"]}</div>
                  </AnimationOnScroll>
                </div>

              </div>
            )
        })
        }
          <div class="hot-100-sticker" />

        </div>
      )
    })

    return (
      <div>
        {/* <Hot100Banner style={{ "--container-width": 'calc((100vh * 0.725) - 45px )', display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center' }} /> */}
        <div class="hot-100-logo" />
        <div id="list">{list}</div>
      </div>
    )
  }

}

export default connect(state => { return { hot100: state.hot100 }}) (Hot100)
